import { Modal, Form, Input } from "antd";
import { useTranslation } from "react-i18next";
import { useUpdatePassword } from "@refinedev/core";
import { PasswordRule } from "@/pages/auth/Register";
import { useGetIdentity } from "@refinedev/core";

export const PasswordChangeDialog = ({ visible, onClose }) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const { data: user } = useGetIdentity();
  const { mutate: updatePassword } = useUpdatePassword();
  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      //TODO:
      updatePassword({
        oldpassword: values.oldPassword,
        newpassword: values.password,
      });
      form.resetFields();
      onClose(); // Close modal after successful operation
    } catch (error) {
      console.log("Validation Failed:", error);
    }
  };

  const handleCancel = async () => {
    form.resetFields();
    onClose(); // Close modal after successful operation
  };

  return (
    <Modal
      title={t("header.updatePassword", "Update Password")}
      // visible={visible}
      open={visible}
      onOk={handleOk}
      onCancel={handleCancel}
      okText={t("pages.login.buttons.ok", "OK")}
      cancelText={t("pages.login.buttons.cancel", "Cancel")}
    >
      <Form
        form={form}
        size="small"
        layout="vertical"
        style={{ paddingTop: 20 }}
      >
        <Form.Item
          name="oldPassword"
          label={t("pages.login.fields.oldpassword", "Old Password")}
          rules={[
            {
              required: true,
              message: t(
                "pages.login.errors.requiredOldPassword",
                "Old Password is required.",
              ),
            },
          ]}
        >
          <Input.Password />
        </Form.Item>
        <Form.Item
          name="password"
          label={t("pages.login.fields.newpassword", "New Password")}
          rules={[
            {
              required: true,
              message: t(
                "pages.login.errors.requiredNewPassword",
                "New Password is required.",
              ),
            },
            ...PasswordRule(t),
          ]}
        >
          <Input.Password />
        </Form.Item>
        <Form.Item
          name="confirmPassword"
          label={t("pages.login.fields.confirmpassword", "Confirm Password")}
          dependencies={["password"]}
          rules={[
            {
              required: true,
              message: t(
                "pages.login.errors.requiredConfirmPassword",
                "Confirm Password is required.",
              ),
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("password") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error(
                    t(
                      "pages.login.errors.notmatch",
                      "The two passwords do not match!",
                    ),
                  ),
                );
              },
            }),
          ]}
        >
          <Input.Password />
        </Form.Item>
      </Form>
    </Modal>
  );
};
